<nav class="tabs-navigation lp-holding-navigation" mat-tab-nav-bar [tabPanel]="tabPanel" mat-stretch-tabs="false" mat-align-tabs="start">
  <a mat-tab-link routerLink="information" class="nav-tab" [queryParams]="{origin: originFundId$ | async}" routerLinkActive
     #rla1="routerLinkActive" [active]="rla1.isActive">
    <mat-icon class="material-icons-outlined notranslate">pie_chart</mat-icon>
    INFORMATION
  </a>
  <a mat-tab-link routerLink="capital-call" class="nav-tab" [queryParams]="{origin: originFundId$ | async}" routerLinkActive
     #rla2="routerLinkActive" [active]="rla2.isActive">
    <mat-icon class="material-icons-outlined notranslate">volume_up</mat-icon>
    CAPITAL CALL
  </a>
  <a *ngIf="(isFunded$ | async)" class="nav-tab" mat-tab-link routerLink="transactions"
     [queryParams]="{origin: originFundId$ | async}" routerLinkActive #rla3="routerLinkActive" [active]="rla3.isActive">
    <mat-icon class="material-icons-outlined notranslate">sync_alt</mat-icon>
    TRANSACTIONS
  </a>

  <a *ngIf="(isFunded$ | async)" class="nav-tab" mat-tab-link routerLink="documents" [queryParams]="{origin: originFundId$ | async}"
     routerLinkActive #rla4="routerLinkActive" [active]="rla4.isActive">
    <mat-icon class="material-icons-outlined notranslate">description</mat-icon>
    DOCUMENTS
  </a>

  <a *ngIf="displaySubscribeTab$ | async" mat-tab-link routerLink="leverage" class="nav-tab" [queryParams]="{origin: originFundId$ | async}" routerLinkActive
     #rla5="routerLinkActive" [active]="rla5.isActive">
    <mat-icon class="material-icons-outlined notranslate">monetization_on</mat-icon>
    SUBSCRIBE
  </a>
</nav>
